import React from 'react';
import * as S from './BookingDetailCard.styles';
import BoardingDropingPointDetails from './BoardingDropingPointDetails/BoardingDropingPointDetails';
import { IBOOKING_DETAIL_CARD } from './../../../../containers/Review/Validation';

const BookingDetailCard = (props: IBOOKING_DETAIL_CARD) => {
  const { busType, operatorName, selectedSeats, bpDetail, dpDetail, cancellationPolicyCB, other_data } = props;
  const goSafeLogo = "https://gos3.ibcdn.com/goSafelogo-1591083260.png"

  if (props) {
    return (
      <section>
        <S.BookingDetailWrap>
          <S.BusDetail>
            <div>
              <S.BusName>
                {operatorName}
                {other_data && (other_data.go_safe || other_data.sf_en) ?
                  <S.GoSafeTag>
                    <img src={goSafeLogo} width='60px' />
                    <span>High Safety and Hygiene</span>
                  </S.GoSafeTag> : null}
              </S.BusName>
              <S.SmallTxt>{busType}</S.SmallTxt>
            </div>
            <S.PopupLink onClick={cancellationPolicyCB}>Cancellation Policy</S.PopupLink>
          </S.BusDetail>
          <S.SeatDetail>
            <S.SmallTxt>Seats Selected</S.SmallTxt>
            <div>
              {selectedSeats &&
                selectedSeats.map(function (seat: string | number) {
                  return <S.SeatNumber key={seat}>&#8226; {seat}</S.SeatNumber>;
                })}
            </div>
          </S.SeatDetail>
        </S.BookingDetailWrap>
        <S.DropingPointWraper>
          <BoardingDropingPointDetails
            cardHdr="Boarding Point Details"
            dateTime={bpDetail.dateTime}
            locationPoint={bpDetail.name}
            cardContent={bpDetail.content}
          />
          <BoardingDropingPointDetails
            cardHdr="Dropping Point Details"
            dateTime={dpDetail.dateTime}
            locationPoint={dpDetail.name}
            cardContent={dpDetail.content}
          />
        </S.DropingPointWraper>
      </section>
    );
  }
  return (
    <section>
      <S.BookingDetailWrap>
        <S.BusDetail>
          <div>
            <S.BusName>KSRTC</S.BusName>
            <S.SmallTxt>Volvo A/C Multi Axle Semi Sleeper 1+1</S.SmallTxt>
          </div>
          <S.PopupLink>Cancellation Policy</S.PopupLink>
        </S.BusDetail>
        <S.SeatDetail>
          <S.SmallTxt>Seats Selected</S.SmallTxt>
          <div>
            <S.SeatNumber>L-35</S.SeatNumber>
            <S.SeatNumber>L-36</S.SeatNumber>
          </div>
        </S.SeatDetail>
      </S.BookingDetailWrap>
      <S.DropingPointWraper>
        <BoardingDropingPointDetails
          cardHdr="Boarding Point Details"
          dateTime="3:30 PM, 21st Feb 2019"
          locationPoint="Majestic Bus Stand"
          cardContent="Here comes the address this can come in two lines also and can belong detailed."
        />
        <BoardingDropingPointDetails
          cardHdr="Dropping Point Details"
          dateTime="3:30 PM, 21st Feb 2019"
          locationPoint="Majestic Bus Stand"
          cardContent="Here comes the address this can come in two lines also and can belong detailed."
        />
      </S.DropingPointWraper>
    </section>
  );
};

export default BookingDetailCard;
